import React, { useState } from 'react';
import './qualification.css';

const Qualification = () => {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="qualification section">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My personel journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? 'qualification__button qualification__active button--flex'
                : 'qualification__button button--flex'
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>
            Education
          </div>

          <div
            className={
              toggleState === 2
                ? 'qualification__button qualification__active button--flex'
                : 'qualification__button button--flex'
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase-alt qualification__icon"></i>
            Experience
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? 'qualification__content qualification__content-active'
                : 'qualification__content'
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Diploma of Higher Education in Web Development</h3>
                <span className="qualification__subtitle">France - Paris</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2021 - 2022
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

           

           

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
              </div>

              <div>
                <h3 className="qualification__title"> Bachelor’s Degree in Engineering in the field of Electric Transport State
                  Engineering University of Armenia (Polytechnic)</h3>
                <span className="qualification__subtitle">Armenia - Yerevan</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2006-2010
                </div>
              </div>
            </div>
          </div>

          <div
            className={
              toggleState === 2
                ? 'qualification__content qualification__content-active'
                : 'qualification__content'
            }
          >
             <div className="qualification__data">
              <div>
                <h3 className="qualification__title">JavaScript Developer</h3>
                <span className="qualification__subtitle">Armenia-Yerevan</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2022 - today
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">WEB INTEGRATOR & WORDPRESS DEVELOPER</h3>
                <span className="qualification__subtitle">France - Paris</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2022 - 2022
                </div>
              </div>
            </div>
            
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">TRAIN MAINTENANCE ENGINEER</h3>
                <span className="qualification__subtitle">France-Perigueux</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2020 - 2021
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">SELLER & REPAIRER EN APPLIANCES</h3>
                <span className="qualification__subtitle">France - Perigueux</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2014 - 2020
                </div>
              </div>
            </div>

            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">ASSISTANT ELECTRICAL ENGINEER</h3>
                <span className="qualification__subtitle">Armenia - Yerevan</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2013-2014
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
